export default "__VITE_ASSET__CgnlO2cG__"